export const companyTypes = {
  COMPANY: "company",
  ENTREPRENEUR: "entrepreneur",
  PERSON: "person"
}


